<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'BranchComponent.vue'
}
</script>

<style scoped></style>
